import {
  IconDropDownButton,
  OptionProps,
} from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/IconDropDownButton';
import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import React from 'react';

import styles from './CaseTreeItem.module.scss';
import { ReactComponent as AddContentIcon } from '@lmt/unicorn-shared/app/icons/add-content.svg';

interface Props {
  options: OptionProps[];
}

export const AddDataBlockButton = (props: Props) => {
  const claims = useClaims();
  return claims.permissions.dataBlockManagement && props.options.length > 0 ? (
    <IconDropDownButton
      iconComponent={<AddContentIcon className={styles.addContentIcon} />}
      options={props.options as OptionProps[]}
      optionListClassName={styles.addContentOptionListContainer}
      enableProgrammaticScroll={true}
    />
  ) : null;
};
